export default function FeatureItem({ title, detail }: any) {
  return (
    <div className="flex justify-between items-center border-b border-gray-200 py-1">
      <div className="text-sm">{title}</div>
      <div className="text-gray-600 text-xs pr-2">{detail}</div>
    </div>
  );
}
